import { createFileRoute } from "@tanstack/react-router";
import { App } from "@/components/poc/App";

type FermentationLabChartsSearch = {
  batches?: string[];
};

export const Route = createFileRoute("/_app/fermentation_lab_charts")({
  validateSearch: (
    search: Record<string, unknown>,
  ): FermentationLabChartsSearch => {
    return {
      batches: (search?.batches || []) as string[],
    };
  },
  component: App,
});
